import Assets from "../../assetIndex";

/**
 * Cermin dari `src/components/Footer/constants.ts` di hanamaru.
 *
 * Isi footer di kedua situs sudah dua kali berbeda diam-diam (nomor Gamma
 * sempat tertinggal satu versi di sini), jadi datanya sekarang ditulis dengan
 * bentuk yang sama di dua tempat -- kalau salah satu berubah, yang lain tinggal
 * disalin, bukan ditebak ulang.
 */

/**
 * Satu-satunya daftar toko fisik di footer.
 *
 * `phoneLabel` kini NOMOR TELEPON saja, tidak pernah WhatsApp. Nomor WhatsApp
 * tidak lagi ditulis sebagai angka di mana pun -- tiap toko yang punya
 * WhatsApp mendapat tombol hijaunya sendiri lewat `whatsappHref`. Alpha belum
 * punya nomor WhatsApp, jadi kartunya tanpa tombol itu.
 */
/**
 * Font lencana Gamma. Gamma satu-satunya toko yang lencananya BUKAN huruf
 * Yunani: hurufnya G Latin dari papan tokonya, dipotong dalam GeoSlab703 Md BT
 * (Tegar, 6 Okt 2026). Gamma kecil (γ) terbaca seperti "y", itu sebabnya
 * masthead `/stores/gamma` di hanamaru pun tidak memakai huruf Yunani.
 *
 * Berkas fontnya ikut ter-deploy bersama situs ini, di-subset ke A-Z, sebagai
 * `/static/fonts/geoslab703-md-bt.woff2`; @font-face-nya ada di
 * `styles/index.scss`. Daftar cadangan di bawah tetap dipakai: itu yang
 * terlihat sesaat sebelum fontnya datang, dan yang menolong kalau berkasnya
 * hilang — bentuknya tetap slab serif, bukan huruf badan teks.
 *
 * Cermin dari `src/constants/storeSigil.ts` di hanamaru.
 */
export const GEOSLAB_STACK =
  '"GeoSlab703 Md BT", "Geometric Slab Serif 703 Md BT", "Geo Slab 703 Md BT", Rockwell, "Roboto Slab", Georgia, serif';

export const STORES = [
  {
    name: "Alpha Store",
    sigil: "α",
    city: "Bekasi",
    address:
      "Sentra Niaga 5 Blok SN5-9 No.39, Kota Harapan Indah, Pusaka Rakyat, Tarumajaya, Bekasi Barat, 17214",
    href: "/stores/alpha",
    mapsUrl: "https://kyou.id/GoToAlpha",
    phoneLabel: "(021) 88898362",
    phoneHref: "tel:+622188898362",
    // Nomor WhatsApp Business Alpha, dikabarkan Afichael 7 Okt 2026. Toko ini
    // sebelumnya cuma punya telepon kantor, jadi kartunya belum punya lencana
    // WhatsApp sama sekali.
    whatsappHref: "https://wa.me/6281513688790",
    tourUrl: "https://360alpha.kyou.id/"
  },
  {
    name: "Beta Store",
    sigil: "β",
    city: "Tangerang",
    address:
      "Jl. Lingkar Barat, Ruko Victoria Lane No.52, Panunggangan, Kec. Pinang, Kota Tangerang, Banten 15143",
    href: "/stores/beta",
    mapsUrl: "https://kyou.id/GoToBeta",
    phoneLabel: "(021) 30488716",
    phoneHref: "tel:+622130488716",
    whatsappHref: "https://wa.me/628568772166",
    tourUrl: "https://360beta.kyou.id/"
  },
  {
    /*
     * Gamma dilayani lewat WhatsApp, tanpa telepon kantor. Nomornya dulu
     * tercetak sebagai teks yang menaut ke `wa.me` -- baris yang terbaca
     * seperti nomor telepon padahal membuka WhatsApp. Sekarang nomor itu
     * hidup di tombolnya saja.
     */
    name: "Gamma Store",
    // Bukan γ. Papan tokonya memakai G Latin ber-slab (Tegar, 6 Okt 2026).
    sigil: "G",
    sigilFont: GEOSLAB_STACK,
    city: "Surabaya",
    address:
      "Galaxy Mall 1 Lantai 3 (Samping Time Zone GM 1 / Seberang XXI) Jl. Dr. Ir. H. Soekarno No.35-39, Mulyorejo, 60115",
    href: "/stores/gamma",
    mapsUrl: "https://kyou.id/GoToGamma",
    whatsappHref: "https://wa.me/6285336697005",
    tourUrl: "https://360gamma.kyou.id/"
  },
  {
    /*
     * Delta tidak punya halaman toko: `/stores/delta` sempat dibuat, lalu
     * dipindah jadi halaman event `/events/5/grand-opening-delta`. Karena itu
     * `href`-nya null dan namanya tidak ditautkan -- alamat di bawahnya sudah
     * menuju peta yang sama.
     *
     * Di hanamaru kartu ini membaca alamatnya dari
     * `components/DeltaStore/constants.ts`; di sini modul itu tidak ada, jadi
     * isinya disalin. Kalau salah satunya berubah di hanamaru, berkas inilah
     * yang harus ikut disunting.
     */
    name: "Delta Store",
    // Segitiga besar, bukan δ kecil: masthead `/stores/delta` di hanamaru
    // menulis **DeltΔ**, huruf itu menutup kata (Tegar, 6 Okt 2026).
    sigil: "Δ",
    city: "Bandung",
    address:
      "Setrasari B1, Jl. Prof. drg. Soeria Soemantri No.11, Sukagalih, Kec. Sukajadi, Kota Bandung",
    href: null,
    mapsUrl: "https://kyou.id/GoToDelta",
    phoneLabel: "(022) 30502052",
    phoneHref: "tel:+622230502052",
    whatsappHref: "https://wa.me/628131273901",
    tourUrl: "https://360delta.kyou.id/"
  },
  {
    name: "Cosplay Corner",
    // Satu-satunya toko tanpa huruf. Dulu lencananya memang tidak dirender;
    // sekarang dapat gantungan baju (Tegar, 6 Okt 2026), karena yang dijual di
    // sana kostum -- jadi bentuknya, bukan inisial.
    sigilIcon: "hanger",
    city: "Tangerang",
    address:
      "Lt 2. Arah Coffee Alam Sutera, Jl. Lingkar Barat, Ruko Victoria Lane, Panunggangan Tim., Kec. Pinang, Kota Tangerang, Banten 15143",
    href: "/stores/cosplay-corner",
    mapsUrl: "https://kyou.id/GoToKCC",
    whatsappHref: "https://wa.me/6285814718148",
    tourUrl: "https://360kcc.kyou.id/"
  }
];

export const PAYMENTS = [
  { src: Assets.BCA, alt: "BCA", title: "Manual Transfer, Instant Confirmation" },
  { src: Assets.Mandiri, alt: "Mandiri", title: "Virtual Account, Instant Confirmation" },
  { src: Assets.BNI, alt: "BNI", title: "Virtual Account, Instant Confirmation" },
  { src: Assets.BRI, alt: "BRI", title: "Virtual Account, Instant Confirmation" },
  { src: Assets.CIMB, alt: "CIMB", title: "Virtual Account, Instant Confirmation" },
  { src: Assets.Permata, alt: "Permata", title: "Virtual Account, Instant Confirmation" },
  { src: Assets.Jenius, alt: "Jenius" },
  { src: Assets.ShopeePay, alt: "ShopeePay" },
  { src: Assets.QRIS, alt: "QRIS" },
  { src: Assets.GoPay, alt: "GoPay" },
  { src: Assets.Dana, alt: "DANA" },
  {
    src: Assets.Paypal,
    alt: "PayPal",
    title: "Pembayaran dengan Paypal",
    href: "https://kyou.id/help/order-and-payments/pembayaran-dengan-paypal"
  }
];

export const SOCIALS = [
  { src: Assets.Instagram, label: "Instagram Kyou", href: "https://www.instagram.com/kyouhobbyshop" },
  { src: Assets.Facebook, label: "Facebook Kyou", href: "https://www.fb.com/kyouhobbyshop" },
  { src: Assets.MessengerSquare, label: "Messenger Kyou", href: "https://m.me/kyouhobbyshop" },
  { src: Assets.Line, label: "Line Kyou", href: "https://www.bit.ly/AddKyou" }
];

/** Jam CS yang sama dengan yang dijanjikan tiap halaman kebijakan retur. */
export const CS_HOURS = "Senin–Sabtu, 07.00–21.00 WIB";

export const CS_OPEN_HOUR = 7;
export const CS_CLOSE_HOUR = 21;

/** Minggu libur; 1 = Senin ... 6 = Sabtu, mengikuti `Date.getUTCDay()`. */
const CS_OPERATING_DAYS = [1, 2, 3, 4, 5, 6];

/** WIB tidak pernah bergeser (tanpa DST), jadi offsetnya cukup satu konstanta. */
const WIB_OFFSET_MS = 7 * 60 * 60 * 1000;

/**
 * Apakah CS sedang menjawab pada saat `now`.
 *
 * Yang tertulis di footer adalah jam operasional utuhnya, selalu; nilai ini
 * cuma mewarnai titik di depannya. Perhitungannya dipaku ke WIB, bukan ke zona
 * waktu perangkat pembaca: jam CS adalah jam kantor Kyou, jadi pembaca di Tokyo
 * yang membuka pukul 23.00 waktu setempat tetap harus melihat titik hijau,
 * karena di Jakarta saat itu pukul 21.00 belum lewat.
 */
export function isCsOpen(now) {
  const wib = new Date(now.getTime() + WIB_OFFSET_MS);
  const day = wib.getUTCDay();
  const hour = wib.getUTCHours();

  return CS_OPERATING_DAYS.indexOf(day) !== -1 && hour >= CS_OPEN_HOUR && hour < CS_CLOSE_HOUR;
}
